"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Crumb = exports.CrumbCounter = exports.CrumbIcon = exports.CloseIcon = exports.CrumbText = exports.Container = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var Icon_1 = require("../Common/Icon");
var CounterPill_1 = require("../CounterPill/CounterPill");
exports.Container = styled_components_1.default.div.attrs({
    className: 'tws-crumb',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tbackground-color: ", ";\n\tborder-radius: 3px;\n\tline-height: 11px;\n\tmargin: 0 6px 6px 0;\n\tpadding: 4px 5px 4px 7px;\n\tmin-height: 26px;\n\tdisplay: inline-flex;\n\talign-items: center;\n"], ["\n\tbackground-color: ", ";\n\tborder-radius: 3px;\n\tline-height: 11px;\n\tmargin: 0 6px 6px 0;\n\tpadding: 4px 5px 4px 7px;\n\tmin-height: 26px;\n\tdisplay: inline-flex;\n\talign-items: center;\n"])), globalVars_module_scss_1.default.mainGray);
exports.Container.displayName = 'CrumbContainer';
exports.CrumbText = styled_components_1.default.div.attrs({
    className: 'tws-crumb--text',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tcolor: ", ";\n\tdisplay: inline-block;\n\tfont-size: 11px;\n\tfont-weight: 500;\n\tpadding-right: 25px;\n\tvertical-align: middle;\n"], ["\n\tcolor: ", ";\n\tdisplay: inline-block;\n\tfont-size: 11px;\n\tfont-weight: 500;\n\tpadding-right: 25px;\n\tvertical-align: middle;\n"])), globalVars_module_scss_1.default.white);
exports.CrumbText.displayName = 'CrumbText';
// TODO: Investigate trimming and/or adding whitespace around icon so the padding doesn't appear so hacky.
exports.CloseIcon = styled_components_1.default.div.attrs({
    className: 'tws-crumb--close-icon',
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tbackground: none;\n\tborder-radius: 2px;\n\tcolor: ", ";\n\tcursor: pointer;\n\tdisplay: ", ";\n\tfont-size: 9px;\n\theight: 16px;\n\tvertical-align: middle;\n\twidth: 16px;\n\tmargin-left: 8px;\n\n\t.tws-i-icon {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\theight: inherit;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n"], ["\n\tbackground: none;\n\tborder-radius: 2px;\n\tcolor: ", ";\n\tcursor: pointer;\n\tdisplay: ", ";\n\tfont-size: 9px;\n\theight: 16px;\n\tvertical-align: middle;\n\twidth: 16px;\n\tmargin-left: 8px;\n\n\t.tws-i-icon {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\theight: inherit;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n"])), globalVars_module_scss_1.default.white, globalVars_module_scss_1.default.displayInlineBlock);
exports.CloseIcon.displayName = 'CloseIcon';
var Spacer = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tpadding: 0px;\n"], ["\n\tpadding: 0px;\n"])));
Spacer.displayName = 'Spacer';
exports.CrumbIcon = styled_components_1.default.div.attrs({
    className: 'tws-crumb--icon',
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tcolor: ", ";\n\tmargin-right: 6px;\n\tfont-size: 11px;\n\tline-height: 13px;\n"], ["\n\tcolor: ", ";\n\tmargin-right: 6px;\n\tfont-size: 11px;\n\tline-height: 13px;\n"])), globalVars_module_scss_1.default.white);
exports.CrumbIcon.displayName = 'CrumbIcon';
exports.CrumbCounter = styled_components_1.default.div.attrs({
    className: 'tws-crumb--counter',
})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tdisplay: ", ";\n\t.tws-counter-pill {\n\t\theight: 18px;\n\t\tpadding: 0 5px;\n\t\tline-height: 18px;\n\t}\n"], ["\n\tdisplay: ", ";\n\t.tws-counter-pill {\n\t\theight: 18px;\n\t\tpadding: 0 5px;\n\t\tline-height: 18px;\n\t}\n"])), globalVars_module_scss_1.default.displayInlineBlock);
exports.CrumbCounter.displayName = 'CrumbCounter';
var Crumb = /** @class */ (function (_super) {
    __extends(Crumb, _super);
    function Crumb(props) {
        var _this = _super.call(this, props) || this;
        _this.getSpacer = _this.getSpacer.bind(_this);
        _this.getClearButton = _this.getClearButton.bind(_this);
        return _this;
    }
    Crumb.prototype.render = function () {
        var _a = this.props.crumb, displayText = _a.displayText, isDismissible = _a.isDismissible, count = _a.count, icon = _a.icon;
        return (React.createElement(exports.Container, null,
            icon ? this.getIcon() : null,
            React.createElement(exports.CrumbText, null, displayText),
            count !== undefined ? this.getCrumbCount() : null,
            isDismissible ? this.getClearButton() : this.getSpacer()));
    };
    Crumb.prototype.getSpacer = function () {
        return React.createElement(Spacer, null);
    };
    Crumb.prototype.getClearButton = function () {
        var value = this.props.crumb.value;
        var onDismiss = this.props.onDismiss;
        return (React.createElement(exports.CloseIcon, { onClick: function () { return onDismiss(value); } },
            React.createElement(Icon_1.Icon, { name: 'close' })));
    };
    Crumb.prototype.getIcon = function () {
        return (React.createElement(exports.CrumbIcon, null,
            React.createElement(Icon_1.Icon, { name: this.props.crumb.icon })));
    };
    Crumb.prototype.getCrumbCount = function () {
        return (React.createElement(exports.CrumbCounter, null,
            React.createElement(CounterPill_1.CounterPill, { actualCount: this.props.crumb.count })));
    };
    return Crumb;
}(React.Component));
exports.Crumb = Crumb;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
